import React from "react";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Ceza Hukuku",
  id: "ceza-hukuku",
  description: "Soruşturma ve kovuşturma evrelerinde her türlü suç isnadına karşı etkin hukuki savunma ve müdafi hizmetleri."
}, {
  title: "Aile ve Boşanma Hukuku",
  id: "aile-bosanma",
  description: "Boşanma, velayet, nafaka ve mal rejimi tasfiyesi süreçlerinde hassasiyetle yürütülen hukuki danışmanlık."
}, {
  title: "Kurumsal Hukuki Danışmanlık",
  id: "kurumsal-danismanlik",
  description: "Şirketlerin operasyonel süreçlerinde risk analizi ve mevzuata uyum süreçlerinin profesyonel yönetimi."
}, {
  title: "Gayrimenkul ve İnşaat Hukuku",
  id: "gayrimenkul-insaat",
  description: "Tapu iptal, tescil, kamulaştırma ve arsa payı karşılığı inşaat sözleşmelerinden doğan uyuşmazlıklar."
}, {
  title: "İş Hukuku",
  id: "is-hukuku",
  description: "İşçi ve işveren haklarının korunması, iş sözleşmelerinin düzenlenmesi ve kıdem-ihbar tazminatı süreçleri."
}, {
  title: "Uzman Arabuluculuk",
  id: "arabuluculuk",
  description: "Dava şartı veya ihtiyari arabuluculuk süreçlerinde tarafsız ve çözüm odaklı müzakere yönetimi."
}, {
  title: "Sigorta ve Tazminat Hukuku",
  id: "sigorta-tazminat",
  description: "Trafik kazaları, poliçe uyuşmazlıkları ve bedensel/maddi zararlardan kaynaklı tazminat talepleri."
}, {
  title: "İdari Yargı",
  id: "idari-yargi",
  description: "İdare tarafından tesis edilen işlemlerin iptali ve tam yargı davalarında hukuki temsil hizmetleri."
}, {
  title: "İcra ve İflas Hukuku",
  id: "icra-hukuku",
  description: "Alacakların tahsili, icra takibi süreçleri ve şirketlerin borç yapılandırma işlemlerinin yönetimi."
}, {
  title: "AYM ve AİHM Başvuruları",
  id: "aym-aihm",
  description: "Temel hak ve özgürlüklerin ihlali durumunda Anayasa Mahkemesi ve AİHM nezdinde bireysel başvurular."
}, {
  title: "Miras Hukuku",
  id: "miras-hukuku",
  description: "Veraset ilamı, vasiyetname düzenleme, ortaklığın giderilmesi ve tenkis davalarının takibi."
}, {
  title: "Bilişim ve Teknoloji Hukuku",
  id: "bilisim-hukuku",
  description: "İnternet üzerinden işlenen suçlar, erişim engelleme ve dijital varlıkların hukuki korunması."
}, {
  title: "Tüketici Hukuku",
  id: "tuketici-hukuku",
  description: "Tüketici hakem heyeti başvuruları ve ayıplı mal/hizmetten doğan uyuşmazlıkların çözümü."
}, {
  title: "Kişisel Verilerin Korunması",
  id: "kvkk",
  description: "Şirketlerin KVKK uyum süreçleri, veri envanteri hazırlığı ve hukuki sorumluluk danışmanlığı."
}];
export default function HukukiUzmanlikAlanlari() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="hukuki-uzmanlık-alanları" className="dark bg-gradient-to-br from-[#0B1222] to-[#1C2533] text-foreground py-24 px-6 md:px-12 lg:px-20 relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={cn("mb-16 md:mb-24 max-w-3xl transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-4xl md:text-5xl font-serif font-bold tracking-tight mb-6 text-[#C9D1D9]">
            Uzmanlık Alanlarımız
          </h2>
          <p className="text-lg text-muted-foreground font-sans font-light leading-relaxed max-w-2xl">
            Av. Arb. Muhammed Çelik Hukuk ve Arabuluculuk Bürosu olarak, hukukun
            çeşitli alanlarında derinlemesine bilgi birikimi ve tecrübemizle
            müvekkillerimize güvenilir çözümler sunuyoruz.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-border/30">
          {services.map((service, index) => {
          const formattedIndex = (index + 1).toString().padStart(2, "0");
          return <Link key={index} data-index={index} to="https://celikhukuk.net/calisma-alanlari/" newTab className={cn("group relative flex flex-col justify-between p-8 md:p-10 border-r border-b border-border/30 bg-transparent transition-all duration-500 hover:bg-accent/5 overflow-hidden min-h-[320px]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")} style={{
            transitionDelay: `${index * 100}ms`
          }}>
                {}
                <div className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#C5A059] transition-all duration-500 ease-out group-hover:w-full" />

                {}
                <div className="flex flex-col h-full justify-between z-10">
                  <span className="text-5xl font-serif text-[#C5A059]/30 font-bold tracking-tighter transition-colors duration-300 group-hover:text-[#C5A059]/50">
                    {formattedIndex}
                  </span>
                  
                  <div className="mt-auto pt-8">
                    <h3 className="text-2xl font-serif font-medium text-[#C9D1D9] leading-tight group-hover:text-white transition-colors duration-300">
                      {service.title}
                    </h3>
                    <p className="mt-4 text-sm text-muted-foreground font-sans font-light leading-relaxed group-hover:text-[#C9D1D9]/80 transition-colors duration-300">
                      {service.description}
                    </p>
                  </div>
                </div>

                {}
                <div className="absolute inset-0 bg-gradient-to-br from-transparent to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              </Link>;
        })}
        </div>
      </div>
    </section>;
}